import { render } from "./BlogRightSide.vue?vue&type=template&id=a48abb90"
import script from "./BlogRightSide.vue?vue&type=script&lang=js"
export * from "./BlogRightSide.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__